/* eslint-disable max-len */
/**
 * Polish translations.
 */
export default {
  ACTION: {
    CANCEL: 'Anuluj',
    CLOSE: 'Zamknij',
    CONFIRM: 'Potwierdzenie',
    CONFIRM_AND_NEXT: 'Potwierdź i następny',
    CONFIRM_AND_SAVE: 'Potwierdź i zapisz',
    CREATE: 'Utwórz',
    DELETE: 'Usuń',
    EDIT: 'Edytuj',
    NEW_POST: 'Nowa publikacja',
    OK: 'OK',
    REJECTED: 'Odrzucono',
    REPLY: 'Odpowiedź',
    SAVE: 'Zapisz',
    SEND: 'Wyślij',
    SKIP_CROP: 'Zignoruj cięcie',
    UPDATE: 'Aktualizacja',
    UPGRADE: 'Dołączyć do klubu'
  },
  ERROR: {
    FAIL_COPYING_TO_CLIPBOARD: 'kopiowanie do schowka nie powiodło się!',
    INSTAGRAM_PUBLISHING_ERROR:
      'Wystąpił błąd podczas udostępniania posta na Instagramie.',
    INSTAGRAM_PUBLISHING_ERROR_MODAL:
      'Wystąpił błąd podczas udostępniania postu na Instagramie. Czy chcesz kontynuować publikację?',
    LINK_ALREADY_EXISTS: 'Link już istnieje',
    LINK_VALIDATION_FAILED: 'Nie udało się zweryfikować linku',
    MANDATORY_FIELD: 'Pole obowiązkowe',
    MAXIMUM_CHARACTERS: 'Osiągnięto maksymalną liczbę znaków',
    MAXIMUM_FILE_SIZE: 'Maksymalny dozwolony rozmiar to 100 MB!',
    MINIMUM_DIMENSIONS: 'Przesłany plik musi mieć minimalne wymiary 480×960',
    PAGE_NOT_APPROVED:
      '❌ Niestety, tym razem nie udało się zatwierdzić Twojej strony. Ale nie martw się! ✨\n Możesz edytować swój profil i poprawić wskazane pola, aby ponownie przesłać go do zatwierdzenia.',
    REACTION_LIKE: 'Wystąpił błąd, spróbuj ponownie później!',
    UNSUPPORTED_FORMAT: 'Format nie jest obsługiwany!',
    VIDEO_CROP: 'Cięcie wideo nie powiodło się!'
  },
  HEADER: {},
  LABEL: {
    ACCEPT_TERMS_AND_CONDITIONS: 'Akceptuję zasady i warunki',
    ADDITIONAL_INFORMATION: 'Additional information',
    ADDRESS: 'Address',
    APPROVED: 'opublikowany',
    ASSETS: 'Obrazy lub filmy (maksymalny rozmiar 100 MB)',
    ASSOCIATE_PRODUCT: 'Produkt stowarzyszony prozis',
    ASSOCIATED_PRODUCTS: 'Powiązane produkty prozis',
    BUSINESS_PAGE: 'Business Page',
    CAPTION: 'Napis',
    CHART_BY: 'Grafika autorstwa',
    COMMENTS: 'Komentarze',
    COMMISSION: 'prowizja',
    COMMISSIONS: 'prowizje',
    COMMISSIONS_LAST_30_DAYS: 'ostatnie 30 dni',
    COMPANY_NETWORK: 'Prozis',
    COMPLETED_WITHOUT_DOOR_NUMBER: 'Full address without house number',
    CONTINUE_WITH_INSTAGRAM: 'Kontynuuj korzystanie z Instagrama',
    COUNTRY: 'Address with country only',
    CREATE_PROFILE: 'Utwórz profil',
    CROPPING_ASSET: 'Cięcie {asset} {ratio}',
    DELETE_POST: 'Usunąć post?',
    DELETE_POST_ARE_YOU_SURE: 'Czy na pewno chcesz usunąć ten post?',
    DESCRIPTION: 'Biografia',
    DOCUMENT: 'Document',
    DOWNLOAD: 'Pobierz',
    DRAFT_PROFILE: 'Szkic',
    EDIT_PROFILE: 'Edytuj profil',
    ENGAGEMENT: 'Interakcja',
    ERROR: 'Błąd',
    FEED: 'pasza',
    FOLLOWERS: 'Obserwujący',
    FRIDAY: 'Friday',
    GALLERY: 'Galeria',
    HIDDEN: 'Does not show address',
    IMAGE: 'obraz',
    INSTAGRAM: 'Instagram',
    INSTAGRAM_ACCOUNT: 'Konto na Instagramie',
    LATEST_FIRST: 'Najnowszy pierwszy',
    LEAST_PROFITABLE: 'Najmniej dochodowe najpierw',
    LIKES: 'Jak',
    LIKES_DELETED: 'Usunięte upodobania',
    LINK: 'Link ',
    LIVE: 'Bezpośredni',
    LIVES: 'Bezpośredni',
    LOCATION_LEVEL_TYPE_CITY_COUNTRY: 'Adres tylko z miastem i krajem',
    LOCATION_LEVEL_TYPE_COMPLETED: 'Pełny adres',
    LOCATION_LEVEL_TYPE_COMPLETED_WITHOUT_DOOR_NUMBER:
      'Pełny adres bez numeru domu',
    LOCATION_LEVEL_TYPE_COUNTRY: 'Adres tylko z krajem',
    MONDAY: 'Monday',
    MORE: '... Zobacz więcej',
    MOST_PROFITABLE: 'Najbardziej dochodowe najpierw',
    NAME: 'Nazwa',
    NEW_FOLLOWERS: 'Nowi obserwujący',
    NEW_POST: 'Nowa publikacja',
    NO_PRODUCTS_FOUND: 'Nie znaleziono żadnego produktu.',
    NUMBER_OF_FILES: '{file} z {files}',
    OLDEST_FIRST: 'Najstarszy pierwszy',
    ORIGINAL: 'Oryginał',
    OTHER_NETWORKS: 'Instagram',
    PAGE_PHOTOS: 'Zdjęcia strony',
    PAST_TIME_DATE: '{value}',
    PAST_TIME_DAYS: '{value} d',
    PAST_TIME_HOURS: '{value} h',
    PAST_TIME_MINUTES: '{value} m',
    PENDING: 'w toku',
    POST: 'Publikacja',
    POST_COMMENTS: 'Komentarze do publikacji',
    POST_PRODUCTS: 'Produkty do publikacji',
    POST_VIEWS: 'Widoki publikacji',
    POSTING_ON_INSTAGRAM: 'Publikowanie na Instagramie',
    POSTS: 'Publikacje',
    PRODUCTS_HASHTAGS: 'Etykiety produktów',
    PRODUCTS_LINKS: 'Linki do produktów',
    PROFESSIONAL_PAGE: 'Strona profesjonalna',
    PROFILE: 'Profil',
    PROFILE_PHOTO: 'Zdjęcie profilowe',
    PROFILE_STATUS: 'Status profilu',
    PROFILE_VIEWS: 'Wyświetlenia profilu',
    PROZIS: 'Prozis',
    PROZIS_COMMUNITY: 'Społeczność Prozis',
    QUESTION: 'Pytanie',
    QUESTION_REPLY: 'Odpowiedz na pytanie',
    QUESTIONS: 'Pytania',
    REELS: 'szpule',
    REJECTED: 'niepublikowany',
    REJECTED_PROFILE: 'Odrzucono',
    REJECTION_REASON: 'Powód odrzucenia',
    REPLY: 'Odpowiedź',
    REQUIRED_FIELDS: 'Pola obowiązkowe',
    RESET: 'Wyczyść',
    SATURDAY: 'Saturday',
    SEARCH: 'Wyszukiwanie',
    SEARCH_AT_LEAST: 'Szukane słowo musi mieć co najmniej 3 znaki!',
    SEE_LESS: 'Hide',
    SEE_MORE: 'Zobacz więcej',
    SEE_ORIGINAL: 'Zobacz oryginał',
    SEE_TRANSLATION: 'Zobacz tłumaczenie',
    SHARE_ON_INSTAGRAM: 'Udostępnij na Instagramie',
    SHARE_PROFILE: 'Udostępnij profil',
    SOCIAL_NETWORK: 'Sieci społecznościowe',
    SOCIAL_NETWORK_COMMISSIONS: 'Komitety sieci społecznościowych',
    SOCIAL_NETWORK_PAGE: 'Strona społecznościowa',
    SOUND: 'Dźwięk',
    SPECIALTIES: 'Specjalności',
    STATISTICS_POST: 'Statystyki publikacji',
    STATISTICS_PROFILE: 'Statystyki profilu',
    STATS_POST_TOTAL: 'Łączne prowizje za publikację',
    STATS_POST_TOTAL_COMMENTS: 'Komentarze/pytania dotyczące publikacji',
    STATS_POST_TOTAL_LIKES: 'Polubienia uzyskane w związku z publikacją',
    STATS_POST_TOTAL_PRODUCTS: 'Produkty powiązane z publikacją',
    STATS_POST_TOTAL_QUESTIONS: 'Odpowiedzi na pytania zawarte w publikacji',
    STATS_POST_TOTAL_VALUE: 'Wartość publikacji',
    STATS_PROFILE_TOTAL: 'Łączne prowizje od publikacji',
    STATS_PROFILE_TOTAL_COMMENTS: 'Komentarze/pytania dotyczące publikacji',
    STATS_PROFILE_TOTAL_FOLLOWERS: 'Nowi obserwujący zyskali',
    STATS_PROFILE_TOTAL_LIKES: 'Polubienia uzyskane za publikacje',
    STATS_PROFILE_TOTAL_POSTS: 'Wartość uzyskana z publikacji',
    STATS_PROFILE_TOTAL_PRODUCTS: 'Powiązane produkty z publikacji',
    STATS_PROFILE_TOTAL_QUESTIONS: 'Odpowiedzi na pytania dotyczące publikacji',
    STORY: 'historia',
    SUCCESS: 'Sukces',
    SUNDAY: 'Sunday',
    TERMS_AND_CONDITIONS: 'Zasady i warunki',
    THURSDAY: 'Thursday',
    TITLE: 'Tytuł',
    TOTAL_VIEWS: 'Łączna liczba wyświetleń',
    TUESDAY: 'Tuesday',
    TYPE_OF_DOCUMENT: 'Document type',
    UNFOLLOWERS: 'Nie śledzący',
    UNREAD: 'Aby przeczytać',
    UPDATE_POST: 'Aktualizacja publikacji',
    UPDATED: 'Zaktualizowano do {date}',
    UPLOAD: 'Przesyłanie plików',
    UPLOADING_FILES: 'Wysyłanie plików',
    USER_NAME: 'Nazwa użytkownika',
    VIDEO: 'wideo',
    VIEW_ALL_COMMENTS: 'Zobacz komentarze na stronie {total} ',
    VIEW_MORE: 'Zobacz więcej',
    VIEWS: 'Wizualizacje',
    VISIBILITY_LEVEL: 'Visibility level',
    WAITING_APPROVAL: 'Oczekuje na zatwierdzenie',
    WARNING: 'Ostrzeżenie',
    WEDNESDAY: 'Wednesday',
    YOUR_PROFILE: 'Twój profil'
  },
  SENTENCE: {
    NO_QUESTIONS_YET: 'Nie ma jeszcze żadnych pytań.',
    TERMS_AND_CONDITIONS:
      'Wchodząc w interakcję z "siecią społecznościową" Prozis (przykładowo i niewyczerpująco, komentując i/lub bezpośrednio udostępniając treści i reakcje), Użytkownik oświadcza, że przeczytał, zrozumiał i zaakceptował poniższe Warunki.\n\nProzis zastrzega sobie prawo do aktualizacji Regulaminu w dowolnym momencie bez uprzedniego powiadomienia. Prozis jest uprawniony do korzystania z wszelkich dostępnych mu środków prawnych i słusznościowych.\n\nUzyskując dostęp do "Sieci społecznościowej", Użytkownik oświadcza, że ma co najmniej 18 lat i przyjmuje wszelką odpowiedzialność za publikacje, komentarze, obrazy i filmy przesłane ("Treści") w samej "Sieci społecznościowej".\n\nTreści muszą należeć do Użytkownika, który oświadcza, że jest autorem i właścicielem wszelkiej własności intelektualnej. Treści nie mogą przedstawiać żadnej konkretnej sytuacji, budynku lub obiektu i/lub być chronione prawem autorskim, znakiem towarowym lub, ogólnie, znakami towarowymi i logo innych firm, chyba że Użytkownik uzyskał niezbędną względną zgodę na ich wykorzystanie.\n\nTreść nie może obejmować żadnej osoby innej niż Użytkownik, chyba że ta sama osoba wyrazi na to zgodę na piśmie, a za jej uzyskanie odpowiada Użytkownik. Użytkownik zwolni Prozis z odpowiedzialności w przypadku szkód spowodowanych wykorzystaniem takich zdjęć i/lub filmów.\n\nPo udostępnieniu, Treści będą wyłączną własnością Prozis, która będzie upoważniona do publikowania i/lub rozpowszechniania i/lub używania i/lub reprodukowania i/lub komunikowania i/lub modyfikowania, za pomocą dowolnych środków technicznych i w dowolny sposób, wyżej wymienionych Treści, bez wykluczenia, bez ograniczeń czasowych i bez prawa do jakiejkolwiek rekompensaty i/lub odszkodowania dla zaangażowanych i/lub zainteresowanych podmiotów.\n\nPo ewentualnym przesłaniu treści, Prozis zastrzega sobie prawo do pozostawienia widocznych tylko materiałów, które według jego własnej niekwestionowanej oceny nie są szkodliwe dla wizerunku innych osób, a także obraźliwe dla obecnych obyczajów lub w inny sposób szkodliwe dla praw innych osób; stronnicze, zniesławiające, obsceniczne, wulgarne, oszczercze, rasistowskie lub stanowiące formę reklamy jakiejkolwiek działalności komercyjnej niezwiązanej z proponowanym tematem lub w jakimkolwiek przypadku mające na celu promowanie jakiejkolwiek marki, produktu, usługi innej niż "Sieć społecznościowa", z Treścią nieoryginalną dla Użytkownika, tj. skopiowaną z innych źródeł, z treścią naruszającą portugalski system prawny, sprzeczną z przyzwoitością publiczną, przepisami dotyczącymi prywatności i ogólnie obowiązującymi przepisami.\n\nProzis zastrzega sobie również prawo do usunięcia, przed lub po publikacji, każdego komentarza, który według własnego uznania może być obraźliwy, nieodpowiedni i/lub niezgodny z duchem "Portalu społecznościowego".\n\nProzis zastrzega sobie również prawo do usunięcia w dowolnym momencie komentarzy i/lub treści opublikowanych w "Social Network", niezależnie lub na wniosek osób trzecich, a także organów sądowych, w przypadku sporów dotyczących legalności lub zasadności wspomnianej publikacji lub komentarza. Tylko wtedy, gdy treść zostanie uznana za odpowiednią przez moderację "Sieci społecznościowej", pozostanie ona widoczna.\n\nPo przesłaniu Treści do "Sieci społecznościowej" Prozis zastrzega sobie prawo do przesyłania lub ponownego udostępniania Treści użytkownika bezpośrednio na swoich platformach cyfrowych w celu promowania swojej marki.',
    WITHOUT_POSTS: 'Nie ma jeszcze żadnych publikacji.',
    WITHOUT_POSTS_STATISTICS:
      'Pomiędzy wybranymi datami nie ma żadnych publikacji.'
  },
  SUCCESS: {
    COPIED_TO_CLIPBOARD: 'Link został pomyślnie skopiowany do schowka!',
    CREATED_SUCCESSFULLY: 'Udało się!',
    ERROR_PUBLISHING_INSAGRAM: 'Post został opublikowany na Instagramie.',
    INSTAGRAM_PUBLISHING_SUCCESS:
      'Post został pomyślnie opublikowany na Instagramie.',
    POST_CREATED_SUCCESSFULLY: 'Udało się!',
    POST_SAVED_SUCCESSFULLY: 'Aktualizacja zakończona sukcesem!',
    POST_SUCCESSFULLY_DELETED: 'Pomyślnie wyeliminowany.',
    SAVED_SUCCESSFULLY: 'Aktualizacja zakończona sukcesem!',
    SUCCESSFULLY_DELETED: 'Usunięto pomyślnie.',
    SUCCESSFULLY_REPLIED: 'Odpowiedź została udzielona.'
  },
  TOOLTIP: {},
  WARNING: {
    ACCPET_TERMS_AND_CONDITIONS: 'Prosimy o zaakceptowanie regulaminu!',
    EMPTY_PROFILE_IMAGE: 'Musisz przesłać zdjęcie profilowe!',
    INVALID_FORM: 'Nieprawidłowy formularz!'
  }
};
